import { Pipe, PipeTransform } from '@angular/core';
import { Note } from '../../classes/note';

@Pipe({
    name: 'noteTextFilter',
    pure: false
})
export class NoteTextFilterPipe implements PipeTransform {

    transform(noteList: Array<Note>, filterValue: string): Array<Note> {
        if (!noteList || !filterValue) {
            return noteList;
        }
        const normalizedFilter = filterValue.toLowerCase();
        return noteList.filter(note =>
            (note.Text || '').toLowerCase().indexOf(normalizedFilter) !== -1
        );
    }

}
